import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id FC6E9489-07CC-4D0D-B93C-44E0E257A365
 * name battery-remove-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-remove-outline.svg
 * tags
 * - Battery 
 */
export const BatteryRemoveOutlineIcon = createSvgIcon(<><path d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C17.3 12 16.63 12.13 16 12.35V6H8V20H12.35C12.61 20.75 13 21.42 13.54 22M21.54 20.12L20.12 21.54L18 19.41L15.88 21.54L14.47 20.12L16.59 18L14.47 15.88L15.88 14.47L18 16.59L20.12 14.47L21.54 15.88L19.41 18L21.54 20.12Z" /></>, 'BatteryRemoveOutlineIcon');
export default BatteryRemoveOutlineIcon